import { render, staticRenderFns } from "./RecipientPane.vue?vue&type=template&id=d1c35962&scoped=true"
import script from "./RecipientPane.vue?vue&type=script&lang=js"
export * from "./RecipientPane.vue?vue&type=script&lang=js"
import style0 from "./RecipientPane.vue?vue&type=style&index=0&id=d1c35962&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c35962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1c35962')) {
      api.createRecord('d1c35962', component.options)
    } else {
      api.reload('d1c35962', component.options)
    }
    module.hot.accept("./RecipientPane.vue?vue&type=template&id=d1c35962&scoped=true", function () {
      api.rerender('d1c35962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/RecipientPane.vue"
export default component.exports